import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

export const RESTOCK_STORE_TARGET_KIND = "restockStore";

export const NEW_RESTOCK_STORE_TARGET_KIND = "newRestockStore";

export const RESTOCK_LOCATIONS_DOCK_PAGE_ID = "data-management-locations";

export const LOCATIONS_PATH = "/restock/data-management/locations";

const NEW_STORE_ROUTE_SEGMENT = "new";

const RESTOCK_STORE_ROUTE_PATTERN = /^\/restock\/data-management\/locations\/([^/?#]+)$/;

const storeRouteSegment = (pathname: string): null | string => {
	const match = RESTOCK_STORE_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return decodeURIComponent(match[1]);
	} catch {
		return null;
	}
};

export const matchRestockStoreReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const segment = storeRouteSegment(pathname);
	return segment && segment !== NEW_STORE_ROUTE_SEGMENT
		? { targetId: segment, targetKind: RESTOCK_STORE_TARGET_KIND }
		: null;
};

export const NEW_RESTOCK_STORE_TARGET: ContinuationTarget = {
	targetId: NEW_STORE_ROUTE_SEGMENT,
	targetKind: NEW_RESTOCK_STORE_TARGET_KIND
};

export const matchNewRestockStoreReceiverRoute = (pathname: string): ContinuationTarget | null =>
	storeRouteSegment(pathname) === NEW_STORE_ROUTE_SEGMENT ? NEW_RESTOCK_STORE_TARGET : null;

export const newRestockStoreReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => `${LOCATIONS_PATH}/${NEW_STORE_ROUTE_SEGMENT}`,
	matchesRoute: matchNewRestockStoreReceiverRoute
};

const restockStoreReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${LOCATIONS_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchRestockStoreReceiverRoute
};

export default restockStoreReceiverIdentityAdapter;
